import { IQuestionsState } from './state';
import { RootState } from '../rootState';
import { WaveGreaterThan } from '@/utils';

export function questions(state: IQuestionsState) {
  return state.questions;
}
export function answers(state: IQuestionsState) {
  return state.answers;
}
export function allMarkets(state: IQuestionsState) {
  const excludeNames = [
    'Nordics',
    'Northern Ireland',
    'Scotland',
    'Wales',
    'Europe'
  ];

  return state.markets.filter((market, index) => {
    if (index === 0) return false;
    if (excludeNames.includes(market.name)) return false;
    return true;
  });
}

export function currentPage(state: IQuestionsState) {
  return state.page;
}
export function currentSearch(state: IQuestionsState) {
  return state.lastSearch;
}
export function currentFormProfile(state: IQuestionsState) {
  return state.lastSearch;
}
export function filteredResults(state: IQuestionsState) {
  return state.filteredResults;
}
export function is2023b(state: IQuestionsState) {
  const years2023b = [202302, 202401];
  if (Array.isArray(state.search.year)) {
    return state.search.year.every((year) => years2023b.includes(year));
  } else {
    return years2023b.includes(state.search.year!);
  }
}
export function is2024b(state: IQuestionsState) {
  const years2024b: Wave2[] = [202402, 202501, 202502];
  if (Array.isArray(state.lastSearch.year)) {
    return state.lastSearch.year.every((year) => years2024b.includes(year));
  } else {
    return years2024b.includes(state.lastSearch.year!);
  }
}

export function showDataConfidence(state, getters, rootState, rootGetters) {
  return !getters.isJMW;
}
export function isJMW(state: IQuestionsState) {
  return (
    Array.isArray(state.lastSearch.year) && state.lastSearch.year.length > 1
  );
}

export function hasMultipleSelects(
  state: IQuestionsState,
  getters,
  rootState,
  rootGetters
) {
  return WaveGreaterThan(state.lastSearch.year, 202302);
}
export function response(state: IQuestionsState) {
  return state.response;
}
export function currentResults(state: IQuestionsState) {
  return state.results;
}

export function filteredMenuSearch(state: IQuestionsState) {
  return state.filterMenuSearch;
}
export function factors(state, getters, rootState: RootState, rootGetters) {
  let profile = rootState.questions.lastSearch;
  if (profile.year == 202302 || profile.year == 202301)
    return state.factors2023;
  if (profile.year == 202202) return state.factors2022B;
  return state.factors;
}

export function barriers(state, getters, rootState, rootGetters) {
  return state.barriers;
}

export function currentData(state: IQuestionsState) {
  return state.researchData;
}
export function allpreferences(state: IQuestionsState) {
  // @ts-ignore
  return state.preferences;
}
export function currentReportID(state: IQuestionsState) {
  return state.reportSelected;
}
export function reportData(state: IQuestionsState) {
  // @ts-ignore
  return state.reportData;
}
export function currentReport(state: IQuestionsState, getters, rootState) {
  let reportSelected = state.reportSelected;
  let reports = getters.reportsItems;
  let report = {};

  Object.keys(reports).forEach(function (key) {
    let item = Object.assign({}, reports[key]);

    if (reportSelected == item.report_id) {
      report = item;

      let color = 'teal-14';
      // @ts-ignore
      if (report.type == 'CSS') color = 'light-blue-5';
      // @ts-ignore
      if (report.type == 'COP') color = 'indigo';
      // @ts-ignore
      if (report.type == 'SUR') color = 'deep-purple-5';
      // @ts-ignore
      if (report.type == 'RAR') color = 'teal-10';

      // @ts-ignore
      if (!report.settings) {
        // @ts-ignore
        report.settings = { color: color, name: '', logo: '' };
      }
      // @ts-ignore
      if (Object.keys(report.settings).length > 0) {
        // @ts-ignore
        report.settings['color'] = color;
        // @ts-ignore
        report.settings['name'] = '';
        // @ts-ignore
        report.settings['logo'] = '';
      }
    }
  });
  return report;
}

export function reportsItems(state, getters, rootState, rootGetters) {
  let destinaList = rootState.travellyze.destinationsIDs2022B;
  let marketsList = rootState.travellyze.marketsOptions2021;
  let demonymList = state.markets;
  let reportsList = state.reports;
  let res = [];

  function areEqual(array1, array2) {
    if (array1.length === array2.length) {
      return array1.every((element) => {
        if (array2.includes(element)) {
          return true;
        }

        return false;
      });
    }

    return false;
  }

  if (reportsList) {
    Object.keys(reportsList).forEach(function (id) {
      let reportItem = Object.assign({}, reportsList[id]);
      let market_name = '';
      let demo = '';
      let destination = '';

      // Get ID
      reportItem.id = reportItem.report_id;

      // Get Market ID
      Object.keys(marketsList).forEach(function (i) {
        if (marketsList[i].value == reportItem.markets) {
          market_name = marketsList[i].label;
        }
      });

      // Get Coumpound Market ID
      if (!market_name) {
        //@todo: este no debería estar usandose
        if (areEqual([11, 12, 13, 14], reportItem.markets))
          market_name = 'United Kingdom';
        if (areEqual([10, 11, 12, 13, 14], reportItem.markets))
          market_name = 'United Kingdom';
        if (areEqual([1, 2, 3, 4], reportItem.markets))
          market_name = 'Nordic Countries';
        if (areEqual([1, 2, 3, 4, 5, 6, 7, 8, 9, 10], reportItem.markets))
          market_name = 'Europe';
      }

      // Get Market Demonym
      Object.keys(demonymList).forEach(function (i) {
        if (demonymList[i].name == market_name) {
          demo = demonymList[i].demo;
        }
      });

      // Get Destination
      Object.keys(destinaList).forEach(function (i) {
        if (destinaList[i].value == reportItem.destinations) {
          destination = destinaList[i].label;
        }
      });

      reportItem.market = market_name;
      reportItem.demo = demo;
      reportItem.destination = destination;
      // @ts-ignore
      res.push(reportItem);
    });
  }
  return res;
}
// Get a Single Question
export function singleQuestion(state, getters, rootState) {
  let searchQuestions = state.questions;
  let questions = {};
  Object.keys(searchQuestions).forEach(function (key) {
    let question = searchQuestions[key];

    if (state.page == question.order) {
      questions = question;
    }
  });
  return questions;
}

// Get the amount of answers done
export function percentAnswers(state, getters, rootState) {
  let searchAnswers = state.answers;
  let totalAnswers = 0;
  Object.keys(searchAnswers).forEach(function (key) {
    let aux = searchAnswers[key];

    if (key == '8' || key == '11') {
      Object.keys(aux).forEach(function (id) {
        totalAnswers++;
      });
    } else {
      totalAnswers++;
    }
  });
  let percent = (totalAnswers * 100) / 27;
  return percent.toFixed(0);
}

// Sort All Reports
export function allReportsSorted(state: IQuestionsState) {
  let reports = state.reports_admin;
  let reportx = state.reports_admin;
  let sorted = [];

  // Sort by time
  let z = Object.keys(reports).sort(function (a, b) {
    let x = reports[a].time_created;
    let y = reports[b].time_created;
    return x === y ? 0 : x < y ? 1 : -1;
  });

  Object.keys(z).forEach(function (key) {
    // @ts-ignore
    sorted.push(reportx[z[key]]);
  });

  return sorted;
}

// Add User data to All Reports
export function allReports(state, getters) {
  let reports = getters.allReportsDetails;
  let users = getters.allUsers;
  let res = [];

  Object.keys(reports).forEach(function (key) {
    let report = reports[key];
    let user = [];

    Object.keys(users).forEach(function (id) {
      if (users[id].user_id == report.user_id) {
        report.user = users[id];
      }
    });
    //if(user) report.user = user
    // @ts-ignore
    res.push(report);
  });

  return res;
}

export function allReportsDetails(state, getters, rootState, rootGetters) {
  let destinaList = rootState.travellyze.destinationsIDs2022A;
  let marketsList = rootState.travellyze.marketsOptions2021;
  let demonymList = state.markets;
  let reportsList = getters.allReportsSorted;
  let res = [];

  function areEqual(array1, array2) {
    if (array1.length === array2.length) {
      return array1.every((element) => {
        if (array2.includes(element)) {
          return true;
        }

        return false;
      });
    }

    return false;
  }

  if (reportsList) {
    Object.keys(reportsList).forEach(function (id) {
      let reportItem = Object.assign({}, reportsList[id]);
      let market_name = '';
      let demo = '';
      let destination = '';

      // Get ID
      reportItem.id = reportItem.report_id;

      // Get Market ID
      Object.keys(marketsList).forEach(function (i) {
        if (marketsList[i].value == reportItem.markets) {
          market_name = marketsList[i].label;
        }
      });

      // Get Coumpound Market ID
      if (!market_name) {
        if (areEqual([11, 12, 13, 14], reportItem.markets))
          market_name = 'United Kingdom';
        if (areEqual([1, 2, 3, 4], reportItem.markets))
          market_name = 'Nordic Countries';
      }

      // Get Market Demonym
      Object.keys(demonymList).forEach(function (i) {
        if (demonymList[i].name == market_name) {
          demo = demonymList[i].demo;
        }
      });

      // Get Destination
      Object.keys(destinaList).forEach(function (i) {
        if (destinaList[i].value == reportItem.destinations) {
          destination = destinaList[i].label;
        }
      });
      reportItem.info = {};
      reportItem.info.market = market_name;
      reportItem.info.demo = demo;
      reportItem.info.destination = destination;
      // @ts-ignore
      res.push(reportItem);
    });
  }
  return res;
}

// Sort Sub Users of the current Account
export function subUsers(state, getters, rootState, rootGetters) {
  let users_admin = state.users_admin;
  let currentUser = rootGetters['travellyze/currentUser'];
  let res = [];

  Object.keys(users_admin).forEach(function (id) {
    if (users_admin[id].market_admin == currentUser.email) {
      // @ts-ignore
      res.push(users_admin[id]);
    }
  });
  return res;
}

// Sort All Users
export function allUsers(state: IQuestionsState) {
  return state.users_admin;
}

// Get the last report loaded
export function reportLoaded(state: IQuestionsState) {
  return state.reportLoaded;
}
